import Vue from 'vue';
import config from '@/config/index';
export default {
    // 获取设备类型下拉列表
    getDeviceTypeList() {
        return Vue.axios.get(`${config.base_url}/roses-platform/deviceCategory/chose`);
    },
    // 设备管理分页
    getDeviceList(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/getPage`,
            method: 'get',
            params
        })
    },
    // 新增设备
    addDevice(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/addDevice`,
            method: 'post',
            data
        })
    },
    // 修改设备
    editDevice(data) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/editDevice`,
            method: 'post',
            data
        })
    },
    // 获取设备详情
    getDeviceDetail(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/getDetail`,
            method: 'get',
            params
        })
    },
    // 根据端口ID获得详情
    getServeDetaiLByPortId(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/protocolVersionServerRelevance/getServerInfoByPortId`,
            method: 'get',
            params
        })
    },
    // 获取历史国标
    getGbHistory(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/deviceCameraChannel/getNvrList`,
            method: 'get',
            params
        })
    },
    // 国标编号获取下拉
    getGbNo(params) {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/generate28181Code`,
            method: 'get',
            params
        })

    },
    // 行业下拉
    getGbIndustryList() {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/gbIndustryList`,
            method: 'get',
        })
    },
    // 设备类型下拉
    getGbDeviceTypeList() {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/gbDeviceTypeList`,
            method: 'get',
        })
    },
    // 网络接入下拉
    getGbNetWorkList() {
        return Vue.axios({
            url: `${config.base_url}/roses-platform/device/gbNetworkList`,
            method: 'get',
        })
    },
    // 城市下拉
    getGbCityList() {
        return Vue.axios({
            url: `${config.base_url}/roses-pub-service/administrativeDivision/getTreeList`,
            method: 'get',
        })
    },
}